var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"page"}},[_c('van-image',{style:({display:'block'}),attrs:{"src":_vm.banr}}),_c('sx-grid'),_c('div',{staticClass:"bg-white pdl-a"},[_vm._v("香港七星堂 (C) 版权所有")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }